import { AccessorsMutatorsDecorator, Model } from "../../helpers";
import { Property } from "./property.model";
import { Guest } from "./guests.model";
import { SmsTemplate } from "./sms-template.model";

/**
 * @class SmsLog
 *
 */
export class SmsLog extends Model {

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {

        return value instanceof Property ? value : new Property(value);
    }

    /**
     * @param {Object|Guest} value
     * @returns {Guest}
     */
    setGuest(value) {

        return value && (value instanceof Guest ? value : new Guest(value));
    }

    /**
     * @param {Object|SmsTemplate} value
     * @returns {SmsTemplate}
     */
    setSmsTemplate(value) {

        return value && (value instanceof SmsTemplate ? value : new SmsTemplate(value));
    }
}


AccessorsMutatorsDecorator('id', 'property', 'sms_template', 'reservation', 'guest', 'user', 'number', 'message', 'consumed_sms', 'created_at', 'user_name')(SmsLog);



// WEBPACK FOOTER //
// ./src/pms-api/models/sms-log.model.js